import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { ProtectedPage } from '~/src/components/templates'
import { useTranslation } from 'react-i18next'
import { TableFreight } from '~/src/components/pages/SettingsListOfFreight/components/TableFreight'
import { freightMocks } from '~/src/components/pages/SettingsListOfFreight/components/mocks/Freight'

export const SettingsListOfFreight: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ProtectedPage pageTitle={t('freight.freight_title')}>
      <Box display={'flex'} justifyContent={'flex-end'} sx={{ mb: '24px', mt: '4px' }}>
        <Button variant="outlined">
          <DownloadIcon fontSize={'small'} />
          <Typography
            sx={{
              marginLeft: '12px',
              fontStyle: 'normal',
              fontSize: 14,
              lineHeight: '24px',
            }}
          >
            {t('freight.download')}
          </Typography>
        </Button>
      </Box>
      <Stack spacing={'22px'}>
        <TableFreight
          data={freightMocks.oceanFred}
          title={t('freight.oceanFred')}
          isOceanFred={true}
        />
        <TableFreight data={freightMocks.inlandCharge} title={t('freight.inlandCharge')} />
      </Stack>
    </ProtectedPage>
  )
}
